export const PRODUCT_TYPE_VALUES = ["COCOA_BEANS", "COCOA_BUTTER", "COCOA_MASS"] as const
export type ProductType = (typeof PRODUCT_TYPE_VALUES)[number]

export const COCOA_GRADE_VALUES = ["GRADE_1", "GRADE_2", "SOUS_GRADE"] as const
export type CocoaGrade = (typeof COCOA_GRADE_VALUES)[number]

export const CURRENCY_VALUES = ["CFA", "EUR", "USD", "GBP"] as const
export type Currency = (typeof CURRENCY_VALUES)[number]

export const CONTRACT_TYPE_VALUES = ["SPOT_CONTRACTS", "FUTURE_CONTRACTS"] as const
export type ContractType = (typeof CONTRACT_TYPE_VALUES)[number]

export const PRICING_MECHANISM_VALUES = [
  "FIXED_PRICE",
  "MARKET_INDEXED",
  "DIFFERENTIAL_PRICE",
  "FLOATING",
] as const
export type PricingMechanism = (typeof PRICING_MECHANISM_VALUES)[number]

export const REFERENCE_MARKET_VALUES = [
  "ICE_LONDON",
  "ICE_NEW_YORK",
  "LIFFE",
  "CME",
] as const

export const REFERENCE_INDEX_VALUES = [
  "ICCO_DAILY",
  "ICCO_MONTHLY",
  "ICO_COMPOSITE",
  "WORLD_BANK_INDEX",
] as const

export const CALCULATION_METHOD_VALUES = [
  "AVERAGE",
  "CLOSING_PRICE",
  "OPENING_PRICE",
  "HIGH_LOW_AVERAGE",
  "SETTLEMENT_PRICE",
] as const

export const MONTH_VALUES = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
] as const

export const INCOTERM_VALUES = [
  "EXW",
  "FCA",
  "CPT",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
] as const

export const CERTIFICATE_VALUES = [
  "FAIRTRADE",
  "RAINFOREST_ALLIANCE",
  "BIO",
  "ORDINAIRE",
] as const

export const REFERENCE_YEARS = Array.from({ length: 11 }, (_, i) =>
  String(2025 + i),
)

export const ORIGIN_DEFAULT = "Côte d'Ivoire"
export const DEFAULT_FARMGATE_PRICE = 1200
